import { cn } from '@/lib/utils';

import { Input } from '@/components/atoms/input';

export type SearchBarProps = {
  defaultQuery?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  classNames?: {
    inputField?: string;
    root?: string;
  };
  rightIcon: React.ReactNode;
  value: string;
};

export function SearchBarInputField({
  defaultQuery,
  onChange,
  rightIcon,
  classNames,
  value,
}: SearchBarProps) {
  return (
    <Input
      classNames={{
        root: cn('flex-grow max-w-[600px] h-10 items-center', classNames?.root),
        input: {
          root: cn(
            'dark:border-neutral-dark-N80 dark:placeholder-neutral-dark-N50 pl-6',
            classNames?.inputField
          )
        },
        rightIcon: 'py-8 pr-9 pointer-events-auto cursor-pointer z-50',
        search: 'text-transparent bg-transparent z-0',
      }}
      type='text'
      name='query'
      onChange={onChange}
      defaultValue={defaultQuery}
      placeholder='Search in FAQ...'
      rightIcon={rightIcon}
      value={value}
      autoComplete='off'
    />
  );
}
